import { Box } from '@fundamentals'
import { Chip } from '@common/material'
import React from 'react'
import { PageUrls } from '@core/page-urls'
import { useRegisterContext } from '@modules/registers/details/RegisterContext'
import {
  PermitStatusCounts,
  RegisterItemPermitProperty,
} from '@core/entities/register/RegisterItem'
import { RegisterItemContentVariant } from '@modules/registers/items/types'
import { Permit } from '@core/entities/permit/Permit'

type ActivePermitStatusChipsProps = {
  registerItemId?: number
  totalPermits?: number
  statusCountArray: Array<PermitStatusCounts>
  onPermitClick?: () => void
}

export const ActivePermitStatusChips: React.FC<
  ActivePermitStatusChipsProps
> = ({ registerItemId, totalPermits, statusCountArray, onPermitClick }) => {
  const { scope, registerId } = useRegisterContext()

  const handleChipClick = () => {
    if (onPermitClick) {
      onPermitClick()
    } else if (registerItemId) {
      window.open(
        PageUrls.registerItemDetails({
          organisationId: scope.organisationId,
          registerId,
          registerItemId,
          tab: 'permits',
        }),
      )
    }
  }

  return (
    <Box display='flex' flexWrap='wrap' gap={1}>
      {totalPermits >= 0 && (
        <Chip
          variant='outlined'
          label={totalPermits}
          size='small'
          onClick={handleChipClick}
        />
      )}
      {statusCountArray.map(({ status, count }) => (
        <Chip
          key={status}
          color={Permit.getStatusChipColor(status)}
          label={`${Permit.getStatusString(status)} (${count})`}
          size='small'
          onClick={handleChipClick}
        />
      ))}
    </Box>
  )
}

type RegisterItemPropertyDateValueProps = {
  registerItemPropertyData: RegisterItemPermitProperty<string>
  variant?: RegisterItemContentVariant
  statusCountArray: Array<PermitStatusCounts>
  onPermitClick?: () => void
}

export const RegisterItemPropertyPermitValue: React.FC<
  RegisterItemPropertyDateValueProps
> = ({ registerItemPropertyData, statusCountArray, onPermitClick }) => {
  if (registerItemPropertyData?.totalPermits === 0) {
    return <Box sx={{ color: 'text.secondary' }}>-</Box>
  }

  return (
    <ActivePermitStatusChips
      totalPermits={registerItemPropertyData?.totalPermits}
      statusCountArray={statusCountArray}
      onPermitClick={onPermitClick}
    />
  )
}
